import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import ProjectSelect from 'components/core/ProjectSelect';
import { Button, Notice } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const ReassignPhotosModal = ({
  onReassignClicked,
  isOpen,
  onRequestClose,
  companyId,
  errorMessage,
}) => {
  const [state, setState] = useState({ projectId: null, projectNodeId: null });

  const onSaveClick = () => {
    if (state.projectId && state.projectNodeId) {
      const { projectId, projectNodeId } = state;
      onReassignClicked({ projectId, projectNodeId });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel="Reassign photos"
      overlayClassName="modal"
      className="modal-content-wrap min-height"
    >
      <button
        type="button"
        className="modal-close-button"
        onClick={onRequestClose}
      >
        <i className="mdi mdi-close" />
      </button>
      <h3 className="modal-title">
        {translate('photos.reassignPhotosModal.title')}
      </h3>
      <form>
        <span className="instructions">
          {translate('photos.reassignPhotosModal.instructions')}
        </span>
        <ProjectSelect
          companyId={companyId}
          initialValue={state.projectId}
          onChange={(project) => {
            setState({
              projectId: project ? project.id : null,
              projectNodeId: project ? project.node_id : null,
            });
          }}
        />
        {errorMessage ? (
          <Notice ccMargin="s none none" color="destroy">
            {errorMessage}
          </Notice>
        ) : null}
        <div className="btn-container">
          <Button color="primary" type="button" onClick={onSaveClick}>
            {translate('photos.reassignPhotosModal.movePhotos')}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

ReassignPhotosModal.propTypes = {
  companyId: PropTypes.number,
  onReassignClicked: PropTypes.func,
  onRequestClose: PropTypes.func,
  isOpen: PropTypes.bool,
  errorMessage: PropTypes.string,
};

ReassignPhotosModal.defaultProps = {
  onReassignClicked: () => {},
  onRequestClose: () => {},
  isOpen: false,
};

export default ReassignPhotosModal;
